module.exports = __webpack_public_path__ + "img/stick_divers_like.e9e51745.svg";